import { createFileRoute } from '@tanstack/react-router';

import ArticleContent from '../-components/ArticleContent';

export const Route = createFileRoute('/_authenticated/articles/$id/')({
    component: ArticleContent,
});
